var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/shift-create.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-4eb607b8!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/shift-create.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShiftCreate.vue
// module id = 697
// module chunks = 1